import React, { useEffect } from 'react';
import useUserCart from '../app/useUserCart';
import { LoadStatus } from '../config/utils';
import { cartStore, resetFetchCart } from '../features/cart/stores/cart.slice';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
   resetFetchUserSubscriptionStatus,
   subscriptionStore,
} from '../features/subscription/stores/subscriptions.slice';
import { accountStore, setAccountDialogOpen } from '../features/account/stores/account.slice';
import { setOrderBarCardLoading } from '../features/order/stores/order-load.slice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { packageStore, resetFetchPackagesStatus } from '../features/package/stores/package.slice';
import MenuItem from '../features/menuItem/MenuItem';
import { menuItemStore } from '../features/menuItem/stores/menuItem.slice';

export default function BlankPage() {
   const dispatch = useAppDispatch();
   const navigate = useNavigate();
   const { fetchPackagesStatus } = useAppSelector(packageStore);
   const { subscriptionModActive, fetchUserSubscriptionStatus } = useAppSelector(subscriptionStore);
   const { fetchCartResponse, fetchCartStatus } = useAppSelector(cartStore);
   const { isLoggedIn } = useAppSelector(accountStore);
   useUserCart({ fetchCart: !subscriptionModActive, fetchShopTasks: true });
   const [searchParams] = useSearchParams();
   const loginParam = searchParams.get('login');
   const { openMenuItem } = useAppSelector(menuItemStore);

   useEffect(() => {
      if (fetchCartStatus === LoadStatus.complete && fetchCartResponse.success) {
         dispatch(resetFetchCart());
         dispatch(setOrderBarCardLoading(false));
      }
   }, [fetchCartResponse]);

   useEffect(() => {
      if (fetchUserSubscriptionStatus === LoadStatus.complete) {
         dispatch(resetFetchUserSubscriptionStatus());
         dispatch(setOrderBarCardLoading(false));
      }
   }, [fetchUserSubscriptionStatus]);

   useEffect(() => {
      if (fetchPackagesStatus === LoadStatus.complete) {
         dispatch(resetFetchPackagesStatus());
      }
   }, [fetchPackagesStatus]);

   useEffect(() => {
      if (loginParam) {
         if (!isLoggedIn) {
            dispatch(setAccountDialogOpen(true));
         } else {
            navigate('/order');
         }
      }
   }, [loginParam]);

   return <>{openMenuItem && <MenuItem open={openMenuItem} />}</>;
}
